'use strict';
import { module } from '../app';

module.service('Magview', [
  '$http', 'authService', 'apiUrl', 'magViewApi', 'pingSvc',
  function ($http, authService, apiUrl, magViewApi, pingSvc) {
    let warmedUp = false;
    let portalWarmedUp = false;

    return {
      getVersion: function () {
        return $http.get(authService.currentMagViewUrl() + '/api/configuration/getversion');
      },

      getServerTime: function () {
        return $http.get(authService.currentMagViewUrl() + '/api/portalLifeCheck/getServerTime')
                    .then(
                      data => data,
                      error => {
                        warmedUp = false;
                        portalWarmedUp = false;
                      });
      },

      
      getServerTimeNotUtc: function () {
        return $http.get(authService.currentMagViewUrl() + '/api/portalLifeCheck/GetServerTimeNotUtc')
                    .then(
                      data => data,
                      error => {
                        warmedUp = false;
                        portalWarmedUp = false;
                      });
      },

      getInstances: function () {
        return $http.get(apiUrl + 'instances');
      },

      pingServer: function (url) {
        return pingSvc.ping(url);
        //return $http.get(url + '/ping/ping.gif');
      },

      warmupPortal: function (url) {
        if (portalWarmedUp)
          return;

        return $http.get(url + '/initialization').then(() => {
          portalWarmedUp = true;
        });
      },

      warmupMagviewApi: function (url) {
        if (warmedUp)
          return;

        return $http.get(url + magViewApi + "/initialization").then(() => {
          warmedUp = true;
        });
      }
    };
  }
]);



// WEBPACK FOOTER //
// ./src/scripts/domains/magview.js